angular
	.module 'App.Repository'
	.factory 'ShippingInformationRepository', ['BaseRepository', (BaseRepository) ->
		class ShippingInformationRepository extends BaseRepository
			@resource = '/shipping_information'
			@isRestricted = true

		return new ShippingInformationRepository
	]
